export default function Td({ text }) {
  return (
    <td
      className={`py-6 px-6 text-md font-medium text-gray-900 whitespace-nowrap`}
    >
      {text}
    </td>
  );
}
